/**
 * @file: app解决方案
 * @author: wence
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';

import './page_website_sescurity.less';

export default class PageAppSolution extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object
    }

    componentDidMount() {
        if (this.isPC()) {
            window.location.href = '/newsite/websitesec';
        }
    }

    render() {
        const url = `/m/apply?name=${encodeURIComponent('#网站安全解决方案#')}`;
        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={'网站安全解决方案'}
                        urlText="免费试用"
                        bgImg={require('../../asset/image/page_websitesec/banner.png')}
                        url={url}
                    />
                </div>

                <div className={'product-des'}>
                    百度全系网站安全服务，针对政企行业量身打造，从检测到攻防一站解决
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'解决方案介绍'} />
                </div>
                <div className="website-solution">
                    基于百度大数据、AI技术实现的分布式漏洞扫描系统和网站内容感知能力，
                    主动检测网站内容，实现快速发现风险资产、漏洞、违规网页内容、篡改挂马页面，有效保障企业资产安全。
                    定期输出内容风险检测报告，规避内容发布风险，及时扼制违规风险，减少企业损失。
                </div>
                <div className="website-solution-card">
                    <div className="website-solution-card-title">智能深度内容检测</div>
                    <div className="website-solution-card-content">
                        基于百度全网搜索数据，检测被挂马、篡改的页面及不合规内容，
                        识别钓鱼仿冒或相关欺诈网页。对网站的新增网页进行动态感知，
                        发现网页出现的威胁内容，多种途径及时反馈，多重预警。
                    </div>
                </div>
                <div className="website-solution-card icon2">
                    <div className="website-solution-card-title">全类型漏洞扫描</div>
                    <div className="website-solution-card-content">
                        应用百度安全指纹特征库，自动扫描服务器及域名等相关资产内容，
                        并有效识别资产所包含的服务和Web应用。对资产进行全方位扫描，
                        漏洞类型覆盖OWASP Top 10 风险类型以及WASC 25种web应用漏洞。
                    </div>
                </div>

                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title={'业务结构'} />
                </div>
                <div className="struct-content">
                    <img src={require('../../asset/image/page_websitesec/bussiness1.png')}/>
                    <img src={require('../../asset/image/page_websitesec/bussiness2.png')}/>
                </div>

                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title={'方案优势'} />
                </div>
                <div className={'product-mod'} style={{paddingBottom: 0}}>
                    {
                        [
                            {
                                url: require('../../asset/image/page_websitesec/icon-yiyong.png'),
                                title: '方便易用',
                                content: 'API接入灵活，即刻拥有安全防护能力'
                            },
                            {
                                url: require('../../asset/image/page_websitesec/icon-24h.png'),
                                title: '7X24小时',
                                content: '提供7*24小时的应急响应漏洞预警服务'
                            },
                            {
                                url: require('../../asset/image/page_websitesec/icon-fuwu.png'),
                                title: '服务稳定',
                                content: '百度的基础服务，稳定性99.99%'
                            },
                            {
                                url: require('../../asset/image/page_websitesec/icon-shuju.png'),
                                title: '数据全面',
                                content: '依托百度大数据高效的感知能力和健全的漏洞数据库'
                            },
                            {
                                url: require('../../asset/image/page_websitesec/icon-dingzhi.png'),
                                title: '定制灵活',
                                content: '覆盖欺诈，违法和风险类型，结合产品需求灵活定制防护能力'
                            },
                            {
                                url: require('../../asset/image/page_websitesec/icon-jiance.png'),
                                title: '检测报告',
                                content: '支持查询检测结果报告输出，直观了解网站状态'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-feature-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.url})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des">{item.content}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>


                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="合作客户" />
                </div>

                <div style={{width: '100%', height: '2.4rem', marginBottom: '1rem', background: '#D8D8D8'}}>
                    <img src={require('../../asset/image/page_websitesec/parnter.png')} width="100%" alt="客户"/>
                </div>

                <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                    <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                        <ProductTitle title="相关产品" />
                    </div>
                    <div>
                        {
                            [
                                {
                                    title: 'DDoS攻击防护',
                                    content: `具备1Tbps抗D能力，采用云端防护模式，客户无需购买或租用硬件清洗设备，
                                        按需使用；同时，百度安全团队全程支持防护；有效防御各类攻击，包括（不限于）流量型、应用型、扫描窥探型、协议漏洞型、协议选项型等DDoS攻击，
                                        如SYN Flood、UDP Flood、DNS Query Flood、CC等，挽回因网站或业务服务中断造成的诸多损失。`,
                                    url: 'https://anquan.baidu.com/product/ddos'
                                },
                                {
                                    title: 'WAF应用防火墙',
                                    content: `由国内领先的Web安全专家组成的技术团队，为不同行业、不同规模的网站提供了革命性的云防护安全模式，
                                        彻底颠覆了过去单点部署WAF形式的被动防护，以网站替身的形式为网站拦截各种SQL注入、XSS跨站、网站挂马、篡改、拖库等黑客攻击，
                                        并做到实时更新防护策略，第一时间防御各种0day漏洞，有效保护用户源站安全。`,
                                    url: 'https://anquan.baidu.com/product/waf'
                                },
                                {
                                    title: '渗透测试',
                                    content: `依托百度二十年的安全积累和培养的安全专家团队，推出的渗透测试服务，是在用户的授权下，
                                        完全模拟黑客的行为，对客户网站进行入侵尝试。帮助用户理解黑客是如何思考的，
                                        比黑客更早的发现网站问题，并在真实的线上环境验证每个漏洞的真实危害，帮助网站及早修复漏洞。`,
                                    url: 'https://anquan.baidu.com/product/penetration'
                                }
                            ].map((item, index) => {
                                return (
                                    <div key={index} className="saas-app-solution-card">
                                        <div className="title">{item.title}</div>
                                        <div className="content">{item.content}</div>
                                        <a href={item.url} target="_blank" className="btn">了解详情</a>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>

                <div className="saas-website-contact">
                    <div className="saas-website-contact-inner">
                        <div className="des">
                            联系我们快速获取免费试用和专家技术支持
                        </div>
                        <a href={url} className="btn btn-border">
                            立即咨询
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/page_website_sescurity.js